import { render, staticRenderFns } from "./singleSignOn.vue?vue&type=template&id=7a218848&"
import script from "./singleSignOn.vue?vue&type=script&lang=js&"
export * from "./singleSignOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports